import React from "react";
import { motion } from "framer-motion";
import { ChevronRight, ShieldCheck } from "lucide-react";
import { fade } from "@/components/SiteLayout";

const STEPS = [
  { label: "Evidence Sources", type: "input" },
  { label: "AI Extraction & Structuring", type: "ai" },
  { label: "Evidence Gap Identification", type: "ai" },
  { label: "Consultant Review & Validation", type: "human" },
  { label: "Board-ready Strategic Recommendation", type: "output" },
];

const STYLES = {
  input: "bg-white border-slate-200 text-slate-700",
  ai: "bg-blue-50 border-blue-200 text-blue-800",
  human: "bg-white border-2 border-blue-600 text-slate-900 font-semibold shadow-[0_10px_30px_-14px_rgba(37,99,235,0.45)]",
  output: "bg-slate-900 border-slate-900 text-white font-semibold",
};

export const WorkflowStrip = ({ className = "" }) => (
  <div className={className} data-testid="workflow-strip">
    <div className="flex flex-wrap items-center justify-center gap-y-3 gap-x-1.5">
      {STEPS.map((s, i) => (
        <React.Fragment key={s.label}>
          <motion.span variants={fade} initial="hidden" whileInView="show" viewport={{ once: true }} custom={i}
            className={`rounded-full border px-4 py-2 text-xs sm:text-sm font-medium text-center transition-transform duration-300 hover:-translate-y-0.5 ${STYLES[s.type]}`}
            data-testid={`workflow-strip-step-${i}`}>
            {s.label}
          </motion.span>
          {i < STEPS.length - 1 && <ChevronRight className="h-4 w-4 text-slate-300 shrink-0" />}
        </React.Fragment>
      ))}
    </div>
    <p className="mt-6 text-center text-sm text-slate-600 flex items-center justify-center gap-2 flex-wrap">
      <ShieldCheck className="h-4 w-4 text-emerald-600 shrink-0" />
      <span>Clients never receive raw AI outputs — every deliverable is reviewed, interpreted and validated by <span className="font-semibold text-slate-800">senior consultants</span>.</span>
    </p>
  </div>
);
